import { FillInTheBlankFormFields } from '@/components/question/forms/fill-in-the-blank/FillInTheBlankForm';
import { useObjectUrls } from '@/data/hook/shared/useObjectUrls';
import { FillInTheBlankQuestion } from '@/models/Question';
import adapterFillInTheBlankForm from '@/utils/questions/adapterFillInTheBlankForm';

export function useFillInTheBlankPreviewQuestion(
  fields: FillInTheBlankFormFields,
): FillInTheBlankQuestion {
  const files = (fields.options ?? [])
    .map(option => option.mediaFile)
    .filter((mediaFile): mediaFile is File => mediaFile instanceof File);

  const urlByFile = useObjectUrls(files);

  return adapterFillInTheBlankForm(fields, mediaFile => {
    if (mediaFile instanceof File) {
      return urlByFile.get(mediaFile) ?? null;
    }
    return typeof mediaFile === 'string' ? mediaFile : null;
  });
}
